import { render } from "./ManageCustomer.vue?vue&type=template&id=11e6520a"
import script from "./ManageCustomer.vue?vue&type=script&lang=js"
export * from "./ManageCustomer.vue?vue&type=script&lang=js"

import exportComponent from "C:\\WORK\\Tamani\\admin-landing\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__